import React from 'react';
import BreadCrumbItem from "./breadcrumbItem";
import SessionCountDown from "./General/sessionCountDown";
import _ from 'lodash';
import { LEGAL_ADVICE_TEXT, TOBA_PATH, TOBA_SHORT_TEXT } from '../helpers/variables';

const currentPath = (path, acceptedRoutes) => {
    for (let j = 0; j < acceptedRoutes.length; j++) {
        if (path === acceptedRoutes[j].key) {
            return acceptedRoutes[j]
        }
    }
};

const BreadCrumb = (props) => {
    let routeId = _.last(props.PathName.split("/"));
    /*
     * when adding a new route, first the new route must be added in the userContentRouter
     * and then in this component. To add it here, you have to add another object to the
     * acceptedRoutes table like below. key value must be equal to the last subpath of
     * the new path. the value is equal to the label you want to be displayed in the breadcrumb
     * the route must be equal to the full route starting from home (/)
     * */
    let acceptedRoutes = [
        {key: '', value: 'Home', route: '/'},
        {key: 'add-solicitor', value: `Create ${LEGAL_ADVICE_TEXT}`, route: '/solicitors/add-solicitor'},
        {key: 'solicitors', value: `${LEGAL_ADVICE_TEXT}s`, route: '/solicitors'},
        {key: 'manage-account', value: 'Manage Account', route: '/manage-account'},
        {key: 'solicitor-groups', value: `${LEGAL_ADVICE_TEXT} Groups`, route: '/solicitors/solicitor-groups'},
        {key: 'edit-solicitor-group', value: `Edit ${LEGAL_ADVICE_TEXT} Group`, route: '/solicitors/solicitor-groups/edit-solicitor-group/' + routeId},
        {
            key: 'app-form-referral-settings',
            value: 'Application form referral settings',
            route: '/app-form-referral-settings'
        },
        {key: 'new-application', value: 'New Application', route: '/new-application'},
        {key: 'application-and-policies', value: 'Applications & Policies', route: '/application-and-policies'},
        {key: 'newUser', value: 'New user', route: '/newUser'},
        {key: 'application-policy', value: 'Application/Policy', route: '/application-and-policies/application-policy/' + routeId},
        {key: `${TOBA_PATH}`, value: `${TOBA_SHORT_TEXT}`, route: `/manage-account/${TOBA_PATH}`},
        {key: 'add-toba', value: 'TOBA', route: '/solicitors/add-toba'},
        {key: `${TOBA_PATH}s`, value: `${TOBA_SHORT_TEXT}s`, route: `/solicitors/${TOBA_PATH}s`},
        {key: 'users', value: 'Users', route: '/users'},
        {key: 'edit-user', value: 'Edit User', route: '/users/edit-user'},
        {key: 'edit-solicitor', value: `Edit ${LEGAL_ADVICE_TEXT}`, route: '/solicitors/edit-solicitor/' + routeId},
        {key: 'notifications', value: 'Notifications', route: '/notifications'},
        {key: 'premium-settings', value: 'Premium Settings', route: '/premium-settings'},
        {key: 'new-premium-settings', value: 'New Premium Settings', route: '/premium-settings/new-premium-settings'},
        {key: 'edit-premium-settings', value: 'Edit Premium Settings', route: '/premium-settings/edit-premium-settings/' + routeId},
        {key: 'add-article', value: 'Create New Article', route: '/articles/add-article'},
        {key: 'articles', value: 'Articles', route: '/articles'},
        {key: 'edit-article', value: 'Edit Articles', route: '/articles/edit-article/' + routeId},
        {key: 'advance-disbursements', value: 'Advance disbursements', route: '/advance-disbursements'},
        { key: 'add', value: 'Create advance disbursement', route: '/advanced-disbursements/add' },
        { key: 'brokers', value: 'Brokers', route: '/brokers' },
        { key: 'add-broker', value: 'Create New Broker', route: '/brokers/add-broker' },
        { key: 'edit-broker', value: 'Edit Broker', route: '/brokers/edit-broker' },
        { key: 'quotes', value: 'Quotes', route: '/quotes' },
        { key: 'quote', value: 'Quote', route: '/quote' },
        { key: 'internal-alerts', value: 'Internal Alerts', route: '/internal-alerts' },
        { key: 'new-internal-alert', value: 'New Internal Alert', route: '/new-internal-alert' },
        { key: 'edit-internal-alert', value: 'Edit Internal Alert', route: '/internal-alerts' + routeId },
    ];
    let currentPaths = props.PathName.split("/");
    if (currentPaths.length === 2) {
        if (((currentPaths[0] === '') && (currentPaths[1] === ''))) {
            currentPaths.splice(1, 1);
        }
        
    }
    return (
        <div className={props.Wrapper}>
            {
                currentPaths.map((path, index) => {
                    let acceptedRoute = currentPath(path, acceptedRoutes)
                    if (acceptedRoute)
                        return <BreadCrumbItem
                            Path={acceptedRoute.route}
                            BreadcrumbStyle={props.BreadcrumbStyle}
                            Push={props.Push}
                            Label={acceptedRoute.value}
                            key={index}
                        />
                    else return null
                })
            }
            <SessionCountDown/>
        </div>
    )
};

export default BreadCrumb;